// isWindows
export default (function() {
  return navigator.userAgent.toLowerCase().indexOf('windows') !== -1;
})();
